import BaseTracker from './base-tracker';

export default class MuteTracker extends BaseTracker {
  start() {
    this._player.addEventListener('volumechange', this._onVolumeChange);
  }

  _onVolumeChange = () => {
    if (this._player.model.volume === 0) {
      this.track();
    }
  };

  stop() {
    this._player.removeEventListener('volumechange', this._onVolumeChange);
  }
}
